<template>
  <div class="incubate">
    <common-layout>
      <div slot="header">
        <div class="incubate-tabs">
          <span
            v-for="(item,index) in tabs"
            :key="item.id"
            @click="handleClick(item.id)"
            :class="{'active_t':active== item.id}"
          >
            {{item.name}}
          </span>
        </div>
      </div>
      <div slot="container">
        <demand v-if="active == 1"></demand>
        <Information v-else-if="active == 2"></Information>
      </div>
    </common-layout>
  </div>
</template>

<script type="text/ecmascript-6">
import CommonLayout from "../../../components/common-layout.vue";
import demand from "./demand";
import Information from "./Information";
export default {
  components: {
    CommonLayout,
    demand,
    Information
  },
  data() {
    return {
      active: 1,
      tabs:[
        {
          id:1,
          name:'投资需求'
        },
        {
          id:2,
          name:'经营信息'
        },
      ]
    }
  },
  methods:{
    // 切换tab
			handleClick(val) {
				this.active = val;
			}
  }
}
</script>

<style scoped lang="scss">
.incubate {
  height: 100%;
  .incubate-tabs {
    // width: 452px;
    height: 50px;
    border: 1px solid #ef9f49;
    display: flex;
    border-radius: 50px;
    overflow: hidden;
    cursor: pointer;

    > span {
      display: inline-block;
      width: 150px;
      height: 50px;
      line-height: 50px;
      font-weight: bold;

      &.active_t {
        background: linear-gradient(to bottom right, #fbc434 0%, #f66b4e 100%);
        color: #fff;
      }
    }
  }
  .policey_nav {
    display: flex;
    align-items: center;
    justify-content: space-between;

    li {
      &.active-Tab {
        color: rgba(255, 255, 255, 0.4);

        &:before {
          display: inline-block;
          padding-right: 0.5rem;
          padding-left: 0.5rem;
          color: rgba(255, 255, 255, 0.4);
          content: "/";
        }
      }
    }
  }
}
</style>
